import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CryoDTO } from 'business/models/Models';

const initialState = Array<CryoDTO>();
const CryoprotectantSlice = createSlice({
  name: 'cryoprotectants',
  initialState,
  reducers: {
    setAllcryoprotectants: (state, action: PayloadAction<CryoDTO[]>) => {
      return action.payload;
    },
    updateCryoprotectants: (state, action: PayloadAction<CryoDTO[]>) => {
      const updatedCryos = state;
      action.payload.forEach((item) => {
        const index = state.findIndex((obj) => obj.id === item.id);
        if (index == -1) {
          updatedCryos.push(item);
        } else {
          updatedCryos[index] = { ...state[index], ...item };
        }
      });
      return updatedCryos;
    },
    deleteCryoprotectants: (state, action: PayloadAction<CryoDTO[]>) => {
      const cryoListAfterDeletion = state.filter(
        (i) => !action.payload.find((f) => f.id === i.id),
      );
      return cryoListAfterDeletion;
    },
  },
});

export const { setAllcryoprotectants, updateCryoprotectants, deleteCryoprotectants } =
  CryoprotectantSlice.actions;

export default CryoprotectantSlice.reducer;
